"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BILLING_ENTITY_CODE = void 0;
var BILLING_ENTITY_CODE = {
  AUS: 'AUS',
  US: 'US',
  UK: 'UK',
  SG: 'SG',
  ASIA_US: 'ASIA_US'
};
exports.BILLING_ENTITY_CODE = BILLING_ENTITY_CODE;